<template>
  <div class="canmar"></div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  export default {
    components: {},
    props: [
    ],
    data () {
      return {
      }
    },
    computed: {
      ...mapGetters([
      ])
    },
    watch: {
    },
    methods: {
      ...mapActions([
      ]),
      hoverCityOver () {
      },
      hoverCityOut (iner) {
      },
      aab () {
      }
    },
    created () {
      setTimeout(() => {
      }, 1000)
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss">
  @import '../assets/scss/variables';
  @import '../assets/scss/mixins';
  .canmar {
    position: relative;
    width: 100%;
    height: 100%;
    &:after {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      width: 0;
      height: 0;
      border-top: 25px solid transparent;
      border-left: 40px solid $white;
      border-bottom: 25px solid transparent;
      content: "";
      cursor: pointer;
    }
  }
</style>




// WEBPACK FOOTER //
// canmar.vue?2e015af1